export enum ROOM_OPENING_DISCOUNT_MODE {
  'AUTO' = 'AUTO',
  'LAST_MINUTE_AUTO' = 'LAST_MINUTE_AUTO',
  'MANUAL' = 'MANUAL',
}

export type RoomOpeningDiscountMode =
  (typeof ROOM_OPENING_DISCOUNT_MODE)[keyof typeof ROOM_OPENING_DISCOUNT_MODE];
